<script>
  import axios from 'axios';
  import Button from '@ui/pico/button.svelte';
  import { onMount } from 'svelte';
  import { api, pages } from '../../config';
  import { exitIfEscape, formatMoney, goto } from '../../util';
  import { user, ux } from '../../store';
  import { getBalance } from '../../services';

  let balance = 0;
  let amount = 5.0;
  $: formattedAmount = formatMoney(amount, 2);

  onMount(async () => {
    const bal = await getBalance();
    balance = bal.usd;
  });

  async function startChargeUp() {
    const headers = {
      'x-webforma-aid': $user.uid,
      'x-webforma-uid': $user.uid,
    };
    const result = await axios.post(
      api.checkout.checkout.url,
      {
        credits: amount,
      },
      { headers }
    );

    $ux.checkout = result.data;
    const url = result?.data?.url;

    if (url) {
      window.location = url;
    }
  }
  function backToDashboard() {
    goto(pages.account.list.url);
  }
</script>

<svelte:window on:keyup={exitIfEscape(pages.account.list.url)} />

<dialog open>
  <article>
    <header>
      <a on:click={backToDashboard} href="#close" aria-label="Close" class="close"
        >&nbsp;</a
      >
    </header>
    <form on:submit|preventDefault={startChargeUp}>
      <hgroup>
        <h2>Charge Up {formattedAmount}</h2>
        <h4>Add credits to your account ({balance} current balance)</h4>
      </hgroup>

      <div class="grid">
        <div>
          <!-- svelte-ignore a11y-autofocus -->
          <input
            autofocus
            bind:value={amount}
            required
            minimum={5}
            step={5}
            type="number"
            placeholder="Enter amount (numbers only"
          />
        </div>
      </div>
      <Button
        type="submit"
        class="secondary"
        iconLeft="battery-charging"
        iconSize={32}>Charge Up</Button
      >
    </form>
  </article>
</dialog>

<style>
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }
  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
